export interface CaseContact {
  ContactID?: string;
  'First Name'?: string;
  'Middle Name'?: string;
  'Last Name'?: string;
  'Date of Birth'?: string;
  Email?: string;
  Phone?: string;
  Address?: string;
  City?: string;
  PostCode?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  [key: string]: unknown;
}

export interface CaseRecord {
  CaseRef: string;
  CaseType?: string;
  case_type?: string;
  case_type_display?: string;
  case_type_name?: string;
  case_type_id?: number;
  stage?: string;
  stage_name_lookup?: string;
  defendant_id?: number;
  defendant_name?: string;
  defendant_address_line_1?: string;
  defendant_address_line_2?: string;
  defendant_address_line_3?: string;
  defendant_address_postcode?: string;
  defendant_email?: string;
  service_address_line_1?: string;
  service_address_line_2?: string;
  service_address_line_3?: string;
  service_address_postcode?: string;
  loc_address_line_1?: string;
  loc_address_line_2?: string;
  loc_address_line_3?: string;
  loc_address_postcode?: string;
  def_sol_id?: number;
  def_sol_firm_name?: string;
  def_sol_address_line_1?: string;
  def_sol_address_line_2?: string;
  def_sol_address_line_3?: string;
  def_sol_address_postcode?: string;
  def_sol_email?: string;
  def_sol_phone?: string;
  assigned_user_id?: string;
  doc_base_directory?: string;
  client_name?: string;
  ClientName?: string;
  joint_claim?: boolean;
  [key: string]: unknown;
}

export interface CaseFileResponse {
  case: CaseRecord;
  contact: CaseContact;
  case_il_questionnaire_answers?: Record<string, unknown>[];
  case_dsar_assessment_outcomes?: Record<string, unknown>[];
  case_settlements?: Record<string, unknown>[];
  case_litigation?: Record<string, unknown>[];
  [key: string]: unknown;
}

export interface CaseNote {
  NoteID: string;
  CaseRef: string;
  Date: string;
  Time: string;
  Solicitor: string;
  Note: string;
  phone_contact?: boolean;
  email_contact?: boolean;
  no_contact?: boolean;
  timestamp?: string;
  created_at?: string;
}

export interface CaseTask {
  TaskID: string;
  CaseRef?: string;
  user_id: string;
  task_from_user_id?: string;
  from_display_name: string;
  assigned_display_name: string;
  Description: string;
  Deadline: string;
  Status: string;
  AllowReminders?: boolean;
  ReminderDateTime?: string;
  created_at?: string;
  updated_at?: string;
}

export interface StageHistoryEntry {
  id: number;
  CaseRef?: string;
  old_stage_id?: number | null;
  new_stage_id?: number | null;
  old_stage_name: string | null;
  new_stage_name: string;
  changed_by: string;
  changed_at: string;
  change_source?: string;
  days_in_stage?: number | null;
  hours_in_stage?: number | null;
}

export interface Solicitor {
  cognito_user_id: string;
  username: string;
  displayName?: string;
  display_name?: string;
}

export interface Defendant {
  defendant_id: number;
  defendant_name: string;
}

export interface DefendantSolicitor {
  defendant_solicitor_id: number;
  def_sol_firm_name: string;
  def_sol_address_line_1?: string;
  def_sol_address_line_2?: string;
  def_sol_address_line_3?: string;
  def_sol_address_postcode?: string;
  def_sol_email?: string;
  def_sol_phone?: string;
}

export interface TimeEntry {
  CaseRef: string;
  User: string;
  Task: string;
  Duration: string;
  Units: number;
  StartTime: string;
  EndTime: string;
}

export const LAYOUT_PLAN: string[][] = [
  ['General', 'Timestamps'],
  ['Defendant Information', 'Litigation'],
  ['Settlements'],
  ['Important Dates'],
  ['DSAR Assessment Outcomes'],
  ['IL Questionnaire Answers'],
];

export const COLLAPSIBLE_CATEGORIES = new Set([
  'DSAR Assessment Outcomes',
  'IL Questionnaire Answers',
  'Important Dates',
]);

export interface CreateNotePayload {
  Note: string;
  user: string;
  phone_contact?: boolean;
  email_contact?: boolean;
  no_contact?: boolean;
}

export interface CreateTaskPayload {
  assigned_to: string;
  description: string;
  deadline: string;
  allow_reminders?: boolean;
  reminder_datetime?: string;
  category?: string;
}

export interface DraftTemplate {
  id: number;
  display_name: string;
  template_name?: string;
  category?: string;
  recipient_type?: string;
  case_type_id?: number;
  is_active?: boolean;
  [key: string]: unknown;
}

export interface EmailTemplate {
  id: number;
  display_name: string;
  template_name?: string;
  subject_template?: string;
  recipient_type?: string;
  category?: string;
  is_active?: boolean;
  [key: string]: unknown;
}

export interface ContactSearchResult {
  ContactID: string;
  name: string;
  email?: string;
  phone?: string;
  [key: string]: unknown;
}

export interface CaseAuditEntry {
  log_type: 'lifecycle' | 'field_change' | 'activity';
  id: number;
  label: string;
  old_value: string | null;
  new_value: string | null;
  user_id: string;
  username: string;
  change_source: string;
  ts: string;
  field_key: string | null;
  entity_type?: string | null;
  entity_id?: string | null;
  metadata?: Record<string, unknown> | null;
}
